import React from "react";
import { CoachClientProfileLayoutSettings } from "../../../../components/settings/coach-client-profile/CoachClientProfileLayoutSettings";
import TrackInfoTool from "../../../../components/tools/TrackInfoTool";
import { useCurrentWorkspace } from "../../../../hooks/useCurrentWorkspace";

export const CoachSettingsClientProfileLayoutRoute = () => {
  return (
    <>
      <CoachClientProfileLayoutSettings />
      <TrackInfoTool
        trackInfo={{
          name: "Coach - Client Profile Layout Settings",
        }}
      />
    </>
  );
};
